// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nZqA","top":"styles_top__3Q3ow"};